// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:43:51

export default {
  "id": "squid-game-s2-play-and-survive",
  "slug": "squid-game-s2-play-and-survive",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ae6e6fa3fce34550b25a74027a57b1b0-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ae6e6fa3fce34550b25a74027a57b1b0/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Squid Challenge: Play to Survive",
      "description": "Squid Challenge: Play to Survive is an intense survival game inspired by the thrilling challenges of the popular survival contest. Players must navigate through a series of deadly trials, testing their reflexes, strategy, and nerve. With each level, the difficulty increases, making it a true test of skill and endurance.",
      "instructions": "Survive all the dangerous challenges and progress through the rounds.\nFollow the game’s rules strictly—one mistake can mean elimination.\nComplete each task within the given time limit to advance.\n\nControls:\n    Tap or Swipe: Interact with objects and move your character.\n    Hold & Release: Stop when required in \"Red Light, Green Light.\"\n    Button Mashing: Use rapid taps for strength-based challenges like Tug of War.",
      "genres": [
        "Shooter",
        "Simulation"
      ],
      "tags": [
        "guns",
        "survival"
      ]
    },
    "zh-CN": {
      "title": "章鱼挑战：生存游戏",
      "description": "章鱼挑战：求生是受热门求生竞赛刺激挑战启发的紧张求生游戏。玩家必须通过一系列致命的试炼，考验他们的反应、策略和神经。随着每个级别的提升，难度也会增加，真正考验玩家的技能和耐力。",
      "instructions": "生存所有危险挑战，通过每一轮。\n\n严格遵守游戏规则——一次失误可能导致淘汰。\n\n在给定时间内完成每个任务以继续前进。\n\n控制方式：\n    点击或滑动：与物体互动并移动你的角色。\n    持续并释放：在“红灯，绿灯”游戏中需要时停止。\n    按钮狂敲：使用快速点击进行基于力量的挑战，如拔河。",
      "genres": [
        "射击",
        "模拟"
      ],
      "tags": [
        "枪械",
        "生存"
      ]
    },
    "zh-TW": {
      "title": "章魚挑戰：求生存",
      "description": "章魚挑戰：求生存是一款受熱門生存競賽刺激挑戰啟發的激烈生存遊戲。玩家必須通過一系列致命的試驗，考驗自己的反應速度、策略和神經。隨著每個關卡的提升，難度也隨之增加，讓它成為一場真正測試技巧和耐力的挑戰。",
      "instructions": "生存所有危險挑戰並通過各回合。\n嚴格遵守遊戲規則——一個錯誤可能意味著淘汰。\n在給定時間內完成每個任務以進階。\n\n控制方式：\n    轻觸或滑動：與物體互動並移動你的角色。\n    持續按壓後放開：在「紅燈綠燈」遊戲中需要時停止。\n    按鈕連擊：用快速點擊來應對如拔河等基於力量的挑戰。",
      "genres": [
        "射擊遊戲",
        "模擬遊戲"
      ],
      "tags": [
        "槍械",
        "生存"
      ]
    },
    "zh-HK": {
      "title": "章魚挑戰：生存遊戲",
      "description": "烏魚挑戰：求生存是一款以熱門生存比賽刺激挑戰為靈感的緊張生存遊戲。玩家必須通過一系列致命的試驗，考驗他們的反應速度、策略和膽量。隨著每個關卡的增加，難度也隨之上升，使其成為技能和耐力的真正考驗。",
      "instructions": "熬過所有危險挑戰，通過各回合。\n嚴格遵守遊戲規則——一個錯誤可能意味著被淘汰。\n在給定時間內完成每個任務以進步。\n\n控制方式：\n    轻觸或滑動：與物件互動及移動角色。\n    縮放：在「紅燈，綠燈」遊戲中，當需要時停止。\n    鍵盤狂按：使用快速觸控以應對如拔河等基於力量挑戰。",
      "genres": [
        "射擊遊戲",
        "模擬遊戲"
      ],
      "tags": [
        "槍械",
        "生存"
      ]
    },
    "ja": {
      "title": "カタツムリチャレンジ：生き延びるために遊ぶ",
      "description": "スカイチャレンジ：生き延びを求めては、人気のサバイバルコンテストの刺激的な挑戦にインスパイアされた激しいサバイバルゲームです。プレイヤーは一連の死の試練を通じて、反射神経や戦略、神経を試されなければなりません。レベルごとに難度が上がるため、これは真正のスキルと耐久力の試練となります。",
      "instructions": "すべての危険な挑戦を生き延び、ラウンドを進めよう。\nゲームのルールを厳しく守れ—一つの間違いで排除されるかもしれません。\n与えられた時間内にタスクを完了して、進む。\n\nコントロール：\nタップまたはスワイプ：オブジェクトと対話し、キャラクターを動かす。\nホールド＆リリース：\"レッドライト、グリーンライト\"で必要に応じて停止。\nボタン叩き：引っ張り合いなどの力に基づく挑戦には、速いタップを使用。",
      "genres": [
        "シューティング",
        "シミュレーション"
      ],
      "tags": [
        "銃",
        "サバイバル"
      ]
    },
    "ko": {
      "title": "오징어 도전: 생존하기 위해 플레이하세요",
      "description": "오징어 도전: 생존하기는 인기 생존 경쟁의 흥미진진한 도전을 영감으로 받은 강력한 생존 게임입니다. 플레이어는 반복되는 치명적인 시험을 통해 반응 속도, 전략, 그리고 정신을 테스트해야 합니다. 각 레벨마다 난이도가 증가하여 실제 기술과 지혜를 시험하는 것입니다.",
      "instructions": "모든 위험한 도전을 극복하고 라운드를 진행하세요.\n게임의 규칙을 철저히 따르세요 — 한 번의 실수가 탈락을 의미할 수 있습니다.\n주어진 시간 내에 모든 임무를 완료하여 진행하세요.\n\n제어 방법:\n    탭하거나 스와이프: 물체와 상호작용하고 캐릭터를 이동하세요.\n    유지하고 방출: \"레드 라이트, 그린 라이트\"에서 필요 시 멈춰하세요.\n    버튼 밀기: 풀어쳐전에서 강력한 도전에 대해 빠른 탭을 사용하세요.",
      "genres": [
        "총살게임",
        "시뮬레이션"
      ],
      "tags": [
        "총",
        "생존"
      ]
    },
    "fr": {
      "title": "Défi Calmar : Joueur pour Survivre",
      "description": "Squid Challenge : Joueur pour Survivre est un jeu de survie intense inspiré des défis captivants du popular concours de survie. Les joueurs doivent naviguer à travers une série de tentations mortelles, testant leurs réflexes, stratégie et nerfs. À chaque niveau, la difficulté augmente, en le rendant un véritable test de compétence et d'endurance.",
      "instructions": "Survivez toutes les épreuves dangereuses et progressez dans les tours.\nSuivez strictement les règles du jeu — une erreur peut entraîner l'élimination.\nTerminez chaque tâche dans le délai imparti pour avancer.\n\nContrôles :\n    Tapoter ou glisser : interagir avec les objets et déplacer votre personnage.\n    Tenir et relâcher : arrêter lorsque nécessaire dans \"Rouge feu, vert feu.\"\n    Taper frénétiquement : utiliser des appuis rapides pour les défis de force comme le Tug of War.",
      "genres": [
        "Tir",
        "Simulation"
      ],
      "tags": [
        "armes",
        "survie"
      ]
    }
  }
};
